export default __webpack_public_path__ + "static/media/gruszka3.3130d30b.png";